import React, { useState } from 'react';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { SingleDatePicker } from 'react-dates';
import moment from 'moment';
import { Container } from './styles';

const VALUE_FORMAT = 'YYYY-MM-DD';

interface AiManagementDatePickerProps {
  id: string;
  value: string;
  onChange: (value: string) => void;
}

const AiManagementDatePicker: React.FC<AiManagementDatePickerProps> = ({ id, value, onChange }) => {
  const [focused, setFocused] = useState(false);

  return (
    <Container>
      <SingleDatePicker
        id={id}
        date={value ? moment(value, VALUE_FORMAT) : null}
        onDateChange={(date) => onChange(date ? date.format(VALUE_FORMAT) : '')}
        focused={focused}
        onFocusChange={({ focused: next }) => setFocused(!!next)}
        placeholder="dd/mm/aaaa"
        displayFormat="DD/MM/YYYY"
        isOutsideRange={() => false}
        hideKeyboardShortcutsPanel
        showClearDate
        small
        block
        numberOfMonths={1}
        openDirection="down"
        anchorDirection="right"
      />
    </Container>
  );
};

export default AiManagementDatePicker;
